export default __webpack_public_path__ + "static/media/variableAclNotConfigured.4b781dc5.svg";